import React from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Box, Toolbar } from "@mui/material";
import useWindowSize from "../../hooks/useWindowSize";
// import i18next from "i18next";
// import { useAuth } from "../../hooks/useAuth";


// import Footer from "./Footer";

const DashboardLayout = ({ children, contentMenu }) => {
  const { width } = useWindowSize();
  
  const isDrawerOpen = true;

  // const isArabic = i18next.language === 'ar';

  const drawerWidth = 250; // Width of the sidebar
  return (
    <>
      <div>
        <Header contentNavigation={contentMenu} />
        {width > 1032 && <Sidebar contentNavigation={contentMenu} />}
      </div>
      {/* Main Content */}
      <Box
    
        component="main"
        sx={{
          flexGrow: 1,
          marginTop: "-3%",
          marginLeft:  isDrawerOpen && width > 1032 ? `${drawerWidth}px` : 0,
          // marginRight: isArabic && isDrawerOpen && width > 1032 ? `${drawerWidth}px` : 0,
          transition: "margin-left 0.3s ease-in-out", // Smooth transition
          padding: isDrawerOpen && width > 1032 ? 2 : 0,
        }}
      >
        <Toolbar /> {/* Spacer to account for fixed AppBar */}
        {children}
      </Box>
      {/* <Footer /> */}
    </>
  );
};

export default DashboardLayout;
